import { NgClass } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
    selector: 'app-fp-navbar',
    imports: [RouterLink, NgClass],
    templateUrl: './fp-navbar.component.html',
    styleUrl: './fp-navbar.component.scss'
})
export class FpNavbarComponent {

    constructor(private router: Router) {}

    // Mobile Menu Toggle
    classApplied = false;

    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    closeMenu() {
        this.classApplied = false;
    }

    @HostListener('document:keydown.escape')
    onEscape() {
        if (this.classApplied) {
            this.closeMenu();
        }
    }

    // Navbar Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])
    @HostListener('document:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 40) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    // Smooth Scroll to Section with accurate header offset
    smoothScroll(sectionId: string) {
        this.closeMenu();
        const doScroll = () => {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        if (this.router.url !== '/' && !this.router.url.startsWith('/#')) {
            this.router.navigate(['/']).then(() => {
                setTimeout(doScroll, 150);
            });
        } else {
            setTimeout(doScroll, 50);
        }
    }

}